import { Chip } from "@mui/material";
import { AppointmentStatus } from "../../../types/types";
import { generalBrightGrey, dmYellow } from "../../../styles/colors";
import { useTranslation } from "react-i18next";

interface AppointmentStatusChip {
  status: string;
}

const AppointmentStatusChip = (props: AppointmentStatusChip) => {
  const { t } = useTranslation();
  let chipLabel = "";
  let chipColor = "";

  switch (props.status) {
    case AppointmentStatus.PENDENT:
      chipLabel = t("appointmentDetails.statusValues.PENDENT");
      chipColor = dmYellow;
      break;
    case AppointmentStatus.CANCELED:
      chipLabel = t("appointmentDetails.statusValues.CANCELED");
      chipColor = "#FCACC5";
      break;
    case AppointmentStatus.CONFIRMED:
      chipLabel = t("appointmentDetails.statusValues.CONFIRMED");
      chipColor = "#ACFCD9";
      break;
    case AppointmentStatus.FINISHED:
      chipLabel = t("appointmentDetails.statusValues.FINISHED");
      chipColor = generalBrightGrey;
      break;
    default:
      chipLabel = props.status;
      chipColor = generalBrightGrey;
      break;
  }

  return (
    <Chip
      label={chipLabel}
      sx={{ backgroundColor: chipColor, fontWeight: "bold" }}
    />
  );
};

export default AppointmentStatusChip;
